// ModalForm.jsx (tu versión con react-bootstrap)
import React, { useState } from 'react'
import { Button, Modal } from 'react-bootstrap'
import { Form, Formik } from 'formik'
import { ModalFormField } from './ModalFormField'
import { requestAuth } from '../../http/httpRequest'
import { useDispatch } from 'react-redux'
import { setRecall1, setRecall2 } from '../../redux/action/globalParamsAction'
import { toastToggleAction } from '../../redux/action/toastAction'
import { useNavigate } from 'react-router-dom'
import ModalConfirmation from '../modal/ModalConfirmation' // <-- usa tu propio modal

export const ModalForm = ({
  show,
  onHide,
  formData,
  method,
  urlApi,
  back,
  title,
  confirmMessage, // <-- NUEVO (opcional)
}) => {
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [confirmOpen, setConfirmOpen] = useState(false)  // <-- NUEVO
  const [pendingValues, setPendingValues] = useState(null) // <-- NUEVO

  const dispatch = useDispatch()
  const navigate = useNavigate()

  // lógica de envío (reutilizable)
  const doSubmit = async (values) => {
    setIsSubmitting(true)
    await requestAuth(method, urlApi, values)
      .then((response) => {
        if (back) {
          dispatch(setRecall1())
          navigate('..')
        } else {
          dispatch(setRecall1())
          dispatch(setRecall2())
        }
        onHide()
        dispatch(
          toastToggleAction({
            show: true,
            bg: 'success',
            title: 'ÉXITO!',
            message: response?.data?.message ?? 'Guardado correctamente!',
            variant: 'bold',
          })
        )
      })
      .catch((error) => {
        dispatch(
          toastToggleAction({
            show: true,
            bg: 'danger',
            title: 'ERROR!',
            message:
              error?.response?.data?.message ??
              'Error al guardar los datos del formulario!',
            variant: 'bold',
          })
        )
      })
      .finally(() => {
        setIsSubmitting(false)
        setConfirmOpen(false)
        setPendingValues(null)
      })
  }

  return (
    <Modal show={show} onHide={onHide} className="elevation-1" size="lg">
      <Modal.Header closeButton style={{ overflow: 'hidden' }}>
        <Modal.Title className="h6 fw-semibold">{title}</Modal.Title>
      </Modal.Header>

      <Formik
        initialValues={formData.initialValues}
        validate={(values) => {
          const errors = {}
          if (formData.validators) {
            Object.entries(formData.validators).forEach(([key, fn]) => {
                const err = fn(values[key])
                if (err) errors[key] = err
            })
          }
          return errors
        }}
        onSubmit={async (values/*, formikActions */) => {
          // Si NO hay confirmación: comportamiento de siempre
          if (!confirmMessage) {
            return doSubmit(values)
          }
          // Con confirmación: abre el modal y guarda los valores
          setPendingValues(values)
          setConfirmOpen(true)
        }}
      >
        {({ values, setFieldValue, handleChange, errors, touched }) => (
          <Form>
            {formData?.fields?.length > 0 && (
              <Modal.Body>
                <ModalFormField
                  formData={formData}
                  values={values}
                  setFieldValue={setFieldValue}
                  handleChange={handleChange}
                  errors={errors}
                  touched={touched}
                />
              </Modal.Body>
            )}
            <Modal.Footer>
              <Button variant="secondary" onClick={onHide}>
                Cancelar
              </Button>
              <Button type="submit" variant="danger" disabled={isSubmitting}>
                Guardar
              </Button>
            </Modal.Footer>

            {/* Modal de confirmación reutilizando tu componente */}
            <ModalConfirmation
              show={confirmOpen}
              handleClose={() => {
                setConfirmOpen(false)
                setPendingValues(null)
              }}
              onClick={() => {
                if (pendingValues) doSubmit(pendingValues)
              }}
              text={confirmMessage || '¿Verificaste que los datos ingresados sean correctos?'}
              buttonText="Aceptar"
              variant="primary"
              buttonDisabled={isSubmitting}
            />
          </Form>
        )}
      </Formik>
    </Modal>
  )
}
